<template>
  <div class="bodys" v-if="body_show">
    <div class="or_t">
      <div v-if="data.buystatus==1 || data.buystatus==3">
        <div v-if="data.refunding">
          <div v-if="data.refund_success">
            <img src="@a/or5.png" alt="" />
            <p>交易关闭</p>
          </div>
          <div v-else>
            <img src="@a/or1.png" alt="" />
            <p>支付成功</p>
          </div>
        </div>
        <div v-else>
          <div v-if="data.swapsinfo">
            <img src="@a/or4.png" alt="" />
            <p>调期成功</p>
          </div>
          <div v-else>
            <div v-if="data.start">
              <img src="@a/or3.png" alt="" />
              <p>已开课</p>
            </div>
            <div v-else>
              <img src="@a/or1.png" alt="" />
              <p>支付成功</p>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <img src="@a/or2.png" alt="" />
        <p>等待支付</p>
        <h5 v-if="data.surplus_time > 1">剩 {{time}} 自动关闭</h5>
        <h5 v-else>支付时间已过期</h5>
      </div>
    </div>
    <div class="or_main">
      <h2>
        <router-link :to="'/course_details?bid='+data.pid">
          <b>{{data.course_name}}</b>
          <img src="@a/href.png" />
        </router-link>
      </h2>
      <div :class="['course','clearfix',data.buystatus==1 || data.buystatus==3?'courses':'']">
        <div class="clearfix">
          <img :src="data.promotionimg" alt="" />
          <div class="course_fg">
            <h3>{{data.name}}</h3>
            <div v-if="data.swapswaiting">
              <h4>您当前的课程期次为待定有再次调整期次的权限</h4>
            </div>
            <div v-else>
              <div v-if="data.start">
                <h4 v-if="data.end==0">{{data.end_time}} 结营</h4>
                <h4 v-else>已结营</h4>
              </div>
              <h4 v-else>{{data.begin_time}} 正式开课</h4>
            </div>
          </div>
          <span class="sp1">￥ {{data.course_price}}</span>
        </div>
        <div class="rk clearfix" v-if="data.buystatus==1 || data.buystatus==3">
          <router-link :to="'/my_course_refund_details?id='+id" class="cf" v-if="data.refunding">{{data.refund_success?'退款成功':'退款中'}}</router-link>
          <div v-else style="float:right">
            <router-link :to="'/my_course_refund?id='+id" v-if="data.refund">申请退款</router-link>
            <router-link :to="'/my_course_swaps?id='+id" v-if="data.swaps" :class="data.swapsinfo?'cf':''">调整期次</router-link>
          </div>
        </div>
      </div>
      <ul class="vr" v-if="data.buystatus==1 || data.buystatus==3">
        <li class="clearfix">填写个人资料
          <router-link :to="'/information?cid='+data.cid" v-if="!data.info && data.buystatus==1">填写资料</router-link>
          <a v-else class="over">填写资料</a>
        </li>
        <li class="clearfix">添加导师微信
          <router-link :to="'/mentor_wechat?cid='+data.cid" :class="data.wecaht?'cf':''" v-if="data.buystatus==1">添加微信</router-link>
          <a v-else class="over">添加微信</a>
        </li>
        <li class="clearfix">开始上课<span v-if="!data.swapswaiting">开课时间：{{data.begin_time}}</span>
          <span v-if="data.buystatus==1">
            <span v-if="data.start">
              <span v-if="data.info && data.wecaht">
                <router-link :to="'/list?cid='+data.cid" v-if="data.click_num>0" :class="data.end==0?'':'cf'">{{data.end==0?"去上课":"重做项目"}}</router-link>
                <a @click="addClick(data.cid)" v-else>开始上课</a>
              </span>
              <a @click="alert_show=true" v-else>开始上课</a>
            </span>
            <a v-else class="ov">开始上课</a>
          </span>
          <a v-else class="over">开始上课</a>
        </li>
      </ul>
    </div>
    <div class="or_main" v-if="data.swapsinfo">
      <h2>
          <b>调期信息</b>
      </h2>
      <h4>原来期次: {{data.swapsname}}  {{data.swapsbegin_time}} 正式上课</h4>
      <h4 v-if="data.swapswaiting">调整期次: 待定</h4>
      <h4 v-else>调整期次: {{data.name}} {{data.begin_time}} 正式上课</h4>
      <h4>调整时间: {{data.pay_time}}</h4>
    </div>
    <div class="or_main">
      <h2>
          <b>订单信息</b>
      </h2>
      <h4>下单时间: {{data.create_time}}</h4>
      <h4 v-if="data.order_num">订单编号: {{data.order_num}}</h4>
      <h4 v-if="data.buystatus==1 || data.buystatus==3">付款时间: {{data.pay_time}}</h4>
      <h3 @click="assistant_show=true" class="hegv">
        <img src="@a/kef.png" alt="" class="kef" />联系客服<img src="@a/href.png" />
      </h3>
    </div>
    <div v-if="data.buystatus==0">
      <div class="into_project" v-if="data.surplus_time > 0" @click="signHandle">去付款</div>
      <div class="into_project into_projectover" v-else>支付时间已过期</div>
    </div>
    <!-- 确认提交弹窗 -->
    <van-popup class="pub_alert" v-model="alert_show">
      <div class="confirm_box">
        <h2>您的课前任务“填写资料”和“添加班主任”还未完成</h2>
        <h3>完成以上课前任务在开始上课吧！</h3>
        <div class="btn_group">
          <a class="cancel" href="javascript:;" @click="alert_show=false">OK</a>
        </div>
      </div>
    </van-popup>
    <!-- 助理二维码弹出层 -->
    <van-popup v-model="assistant_show" class="pop_assistant">
      <div class="pop_assistant_box">
        <img src="@a/details_new.png" />
        <h3><span>长按添加助理<br/>领取更多</span><span class="on">课程资料</span></h3>
      </div>
    </van-popup>
    <public-mobile ref="handle" @refiers="pullData" :id="id" :type="'course'"></public-mobile>
  </div>
</template>
<script>
import {
  mc_orderDetail,
  mc_goToClass
} from "@/api/person"
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        data: {},
        id: null,
        alert_show: false,
        assistant_show: false,
        time: null,
        sin: null
      };
    },
    methods: {
      pullData() {
        this.id = this.$route.query.id;
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        mc_orderDetail({
          id: this.$route.query.id
        }).then(data => {
          this.data = data;
          this.body_show = true;
          this.$toast.clear();
          if (data.buystatus == 0) {
            this.timeTostring();
          }

        });
      },
      addClick(cid) {
        mc_goToClass({
          id: this.id
        }).then(data => {
          this.$router.push({
            path: '/list',
            query: {
              'cid': cid
            }
          })
        });
      },
      // 付款
      signHandle() {
        this.$refs.handle.pay_order()
      },
      // 当前时间的格式化字符串
      timeTostring() {
        if (this.data.surplus_time > 0) {
          this.sin = setInterval(() => {
            var secondTime = parseInt(this.data.surplus_time); // 秒
            var minuteTime = 0; // 分
            var hourTime = 0; // 小时
            if (secondTime > 60) { //如果秒数大于60，将秒数转换成整数
              //获取分钟，除以60取整数，得到整数分钟
              minuteTime = parseInt(secondTime / 60);
              //获取秒数，秒数取佘，得到整数秒数
              secondTime = parseInt(secondTime % 60);
              //如果分钟大于60，将分钟转换成小时
              if (minuteTime > 60) {
                //获取小时，获取分钟除以60，得到整数小时
                hourTime = parseInt(minuteTime / 60);
                //获取小时后取佘的分，获取分钟除以60取佘的分
                minuteTime = parseInt(minuteTime % 60);
              }
            }
            var result = ((secondTime < 10) ? "0" : "") + parseInt(secondTime);

            if (minuteTime > 0) {
              result = ((minuteTime < 10) ? "0" : "") + parseInt(minuteTime) + ":" + result;
            }
            if (hourTime > 0) {
              result = ((hourTime < 10) ? "0" : "") + parseInt(hourTime) + ":" + result;
            }
            this.time = result;
            this.data.surplus_time -= 1;
          }, 1000);
        } else {
          clearInterval(this.sin)
        }

      }
    },
    created() {
      this.pullData();
      shareCon("index", this);
    },
    destroyed() {
      clearInterval(this.sin)
    }
};
</script>
<style lang="scss" scoped>
.or_t {
  text-align: center;
  padding: 30px 0;
  img {
    width: 94px;
  }
  p {
    font-size: 34px;
    color: #333;
    margin-top: 20px;
  }
  h5 {
    color: #999;
    font-size: 24px;
    margin-top: 10px;
  }
}

.or_main {
  width: 690px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  margin: 0 auto;
  padding: 20px;
  margin-top: 16px;
  h2 {
    padding-bottom: 10px;
    border-bottom: 2px solid #ccc;
    color: #333;
    font-size: 28px;
    a {
      display: block;
      width: 100%;
      height: 100%;
      color: #333;
      img {
        display: inline-block;
        width: 26px;
        vertical-align: inherit;
        margin-left: 10px;
      }
    }
    b {
      width: 320px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: normal;
      display: inline-block;
    }
  }
  .course {
    display: block;
    margin-top: 20px;
    position: relative;
    .course_fg {
      width: 280px;
      float: left;
      margin-left: 20px;
      h3 {
        color: #333;
        font-size: 26px;
      }
      h4 {
        color: #999;
        font-size: 24px;
        margin-top: 0;
      }
    }
    img {
      width: 200px;
      float: left;
    }
    span.sp1 {
      color: #333;
      font-size: 26px;
      float: right;
    }
  }
  .courses {
    border-bottom: 2px solid #ccc;
    padding-bottom: 30px;
  }
  ul.vr {
    li {
      color: #333;
      font-size: 26px;
      line-height: 48px;
      margin-top: 30px;
      span {
        color: #999;
        font-size: 20px;
        margin-left: 10px;
      }
      a {
        width: 134px;
        height: 48px;
        background-color: #EB5032;
        color: #fff;
        border-radius: 24px;
        font-size: 24px;
        line-height: 48px;
        text-align: center;
        margin-left: 10px;
        display: inline-block;
        float: right;
      }
      .over {
        background-color: #CCCCCC;
        border-color: #CCCCCC;
        color: #fff;
      }
      .cf {
        border: 2px solid rgba(235, 80, 50, 1);
        color: #EB5032;
        background-color: #fff;
      }
      .ov {
        border: 2px solid #ccc;
        color: #ccc;
        background-color: #fff;
      }
    }
  }
  h3.hegv {
    font-size: 24px;
    color: #999;
    margin-top: 20px;
    border-top: 2px solid #ccc;
    padding-top: 30px;
    img {
      display: inline-block;
      width: 26px;
      vertical-align: inherit;
      margin-left: 10px;
      float: right;
    }
    .kef {
      margin-right: 15px;
      margin-left: 0;
      float: none;
    }
  }
  h4 {
    font-size: 24px;
    color: #999;
    margin-top: 20px;
  }
}

.into_project {
  background: #EB5032;
  width: 100%;
  max-width: 750px;
  line-height: 98px;
  height: 98px;
  position: fixed;
  left: 50%;
  margin-left: -375px;
  bottom: 0;
  text-align: center;
  z-index: 2;
  font-size: 34px;
  color: #fff;
}

.into_projectover {
  background-color: #ccc;
}

.confirm_box h2 {
  padding: 25px 20px;
  padding-bottom: 10px
}

.confirm_box h3 {
  margin: 10px 0;
  color: #999;
  font-size: 26px;
  text-align: center;
}

.confirm_box .btn_group a.cancel {
  width: 100%;
  color: #EB5032
}


/*弹窗带二维码的*/

.pop_assistant {
  text-align: center;
  background-color: transparent;
  .pop_assistant_box {
    width: 600px;
    border-radius: 8px;
    background-color: #fff;
    padding: 105px 85px 84px;
    img {
      width: 434px;
      height: 434px;
    }
    h3 {
      margin-top: 44px;
      font-size: 34px;
      color: #333333;
      line-height: 50px;
      span.on {
        color: #EB5032;
      }
    }
    h4 {
      margin-top: 16px;
      font-size: 24px;
      color: #666;
      line-height: 20px;
    }
  }
}

.rk {
  margin-top: 30px;
  text-align: right;
  a {
    width: 134px;
    height: 48px;
    background-color: #EB5032;
    color: #fff;
    border-radius: 24px;
    font-size: 24px;
    line-height: 48px;
    text-align: center;
    margin-left: 10px;
    display: inline-block;
  }
  .over {
    background-color: #CCCCCC;
    border-color: #CCCCCC;
    color: #fff;
  }
  .cf {
    border: 2px solid rgba(235, 80, 50, 1);
    color: #EB5032;
    background-color: #fff;
  }
  .ov {
    border: 2px solid #ccc;
    color: #ccc;
    background-color: #fff;
  }
}
</style>
